import { Action } from 'redux'
import { Report } from '../../dtos/Report'

const ReportsActions = {
    FETCH_REPORTS: 'FETCH_REPORTS',
    SET_REPORTS: 'SET_REPORTS',
    SELECT_REPORT: 'SELECT_REPORT',
    DELETE_REPORT: 'DELETE_REPORT',
    SOFT_DELETE_REPORT: 'SOFT_DELETE_REPORT'
}

export interface SetReportsAction extends Action {
    reports: Report[]
}

export interface FetchReportsAction extends Action {
    serviceContractOnly: boolean
}

export interface SelectReportAction extends Action {
    report: Report
}

export interface DeleteReportAction extends Action {
    reportId: number
}

export interface SoftDeleteReportAction extends DeleteReportAction {
    reportId: number
}

export default ReportsActions
